import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { IncidentTrackerService } from "../../../shared/services/incident-tracker.service";

@Component({
  selector: "template-create-modal",
  templateUrl: "template-create-modal.html",
  styleUrls: ["template-create-modal.scss"],
})
export class TemplateCreateModalDialogComponent {
  frequencies: any;
  auditTypes: any;
  assessmentTags: any;
  usersList: any;
  isTemplateFileRequired: boolean = true;
  responseOptions: any = [];
  selectedResponses: string[] = [];
  templateForm = new FormGroup({
    title: new FormControl("", [Validators.required]),
    description: new FormControl(""),
    applicability: new FormControl(""),
    focus_area: new FormControl(""),
    internal_assessor: new FormControl(""),
    external_assessor: new FormControl(""),
    is_external_assessment: new FormControl(false),
    frequency: new FormControl("", [Validators.required]),
    type: new FormControl("", [Validators.required]),
    responses: new FormControl([], [Validators.required]),
  });

  constructor(
    public dialogRef: MatDialogRef<TemplateCreateModalDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly incidentTrackerService: IncidentTrackerService
  ) {}

  ngOnInit() {
    this.isTemplateFileRequired = this.data?.isFileRequired !== false;
    this.getFrequencies();
    this.getAuditTypes();
    this.getUsers();
    const responsesControl = this.templateForm.get("responses");
    if (!this.isTemplateFileRequired) {
      responsesControl?.setValidators([Validators.required]);
      this.getResponseOptions();
    } else{
      responsesControl?.clearValidators();
    }
  }

  getResponseOptions() {
    this.incidentTrackerService
      .getAuditResponseChoices()
      .subscribe((resp: any) => {
        this.responseOptions = resp;
      });
  }

  getUsers() {
    this.incidentTrackerService.getUser().subscribe((resp: any) => {
      this.usersList = resp;
    });
  }

  getAuditTypes() {
    this.incidentTrackerService.getAuditTypes().subscribe((response) => {
      this.auditTypes = response;
    });
  }

  getFrequencies() {
    this.incidentTrackerService.getFrequencies().subscribe((response) => {
      this.frequencies = response;
    });
  }

  getChildTags(data: any) {
    this.assessmentTags = data;
  }

  createAssessment() {
    const dialogData = this.templateForm.value;
    dialogData["selectedTags"] = this.assessmentTags;
    this.dialogRef.close(dialogData);
  }

  addResponse(value: string): void {
    if (value && !this.selectedResponses.includes(value)) {
      this.selectedResponses.push(value);
      this.templateForm.get("responses")?.setValue(this.selectedResponses);
    }
  }

  removeResponse(index: number): void {
    this.selectedResponses.splice(index, 1);
    this.templateForm.get("responses")?.setValue(this.selectedResponses);
  }

  closeModal(id: any): void {
    this.dialogRef.close(id);
  }
}
